import React from "react";

export default function AboutUs() {
  return (
    <section className="about-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="about-img">
              <img src="/assets/about-img.jpg" alt="about" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="about-content primary-heading color-dark">
              <h3>About Us</h3>
              <p className="text-justify">Welcome to Bnr 360 Freelance Platform, your premier destination for freelance services. We're dedicated to bridging the gap between talented freelancers and clients in need of specialized expertise.</p>
              <p className="text-justify">At Bnr 360 Freelance Platform, we simplify the freelance experience with our intuitive platform. We strive to connect freelancers with opportunities seamlessly, making it easier than ever to find the perfect match for your project needs.</p>
              <p className="text-justify">Quality, reliability, and transparency are at the core of everything we do. We meticulously vet freelancers to ensure they meet our high standards, giving clients peace of mind knowing they're working with top-notch professionals.</p>
              <p className="text-justify">Join us and experience the future of freelancing with Bnr360 Freelance Platform.</p>
              <p className="text-justify">Contact us at: <a href="mailto:bnr360freelanceplatform@gmail.com">bnr360freelanceplatform@gmail.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
